import MIcon from "./MIcon.vue";
export default MIcon;
export type { MIconProps, MIconSize } from "./MIcon.props";
